const features = [
  {
    title: "iOS Platform",
    subtitle: "Modern development",
    bgClass: "bg-primary-500",
    overlayClass: "",
  },
  {
    title: "Clean Architecture",
    subtitle: "Scalable by design",
    bgClass: "bg-secondary-500",
    overlayClass: "",
  },
  {
    title: "Performance",
    subtitle: "Optimized systems",
    bgClass: "bg-primary-700",
    overlayClass: "",
  },
];

export default function FeatureSection() {
  return (
    <section className="relative w-full bg-background-50 py-24 md:py-32 lg:py-40 px-8 md:px-16 lg:px-24">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-center text-[clamp(28px,3.8vw,44px)] font-bold text-foreground-950 font-heading mb-16 md:mb-24">
          What We Deliver
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className={`relative aspect-square rounded-2xl overflow-hidden ${feature.bgClass}`}
            >
              <div className="absolute inset-0 bg-black/30"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
                <h3 className="text-2xl md:text-[26px] font-bold text-background-50 font-heading leading-tight">
                  {feature.title}
                </h3>
                <p className="mt-1 text-sm md:text-base text-background-50/80 font-light">
                  {feature.subtitle}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}